import cx from "classnames";
import React, { FC, useState, useEffect, useRef } from "react";
import { client } from "../../utils/client";
import { StoreContext } from "../../utils/storeContext";
import anime from "animejs";

import Img from "gatsby-image";
import { useStaticQuery, graphql } from "gatsby";
import Select from "react-select";

import Slider from "@material-ui/core/Slider";

import styles from "./searchBar.module.scss";
import { makeStyles } from "@material-ui/core";
import { Salary, Family, Role } from "../../interface/interfaces";
import { gtagService } from "../../utils/gtag";

const SearchBar: FC = () => {
  const { state, update } = React.useContext(StoreContext);
  const data = useStaticQuery(graphql`
    query {
      searchIcon: file(relativePath: { eq: "search-icon.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      tick: file(relativePath: { eq: "tick.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  const [mobile] = React.useState<boolean>(typeof window !== `undefined` ? window.innerWidth <= 750 : false);
  const [firstResearch, setFirstResearch] = React.useState<boolean>(true);

  const rangeStyles = makeStyles({
    markLabelActive: {
      color: "#a077de",
    },
    markLabel: {
      fontSize: "10px",
      marginTop: "15px",
    },
    mark: {
      backgroundColor: "transparent",
    },
    rail: {
      height: "10px",
      borderRadius: "5px",
      backgroundColor: "grey",
      opacity: "0.25",
    },
    track: {
      height: "10px",
      backgroundColor: "#a077de",
      borderRadius: "5px",
    },
    thumb: {
      width: "20px",
      height: "20px",
      backgroundColor: "#a077de",
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.3)",
    },
  });

  const selectStyles = {
    control: () => ({
      opacity: "0.5",
      marginTop: "2px",
    }),
    placeholder: () => ({
      opacity: "0.5",
    }),
    dropdownIndicator: () => ({
      display: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    input: () => ({
      outlineStyle: "none",
    }),
    menu: provided => ({
      ...provided,
      margin: mobile ? "0px 0px 0px -55px" : "0px 0px 0px -60px",
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)",
      width: "auto",
    }),
    menuList: () => ({
      maxHeight: "200px",
      overflow: "auto",
      backgroundColor: "white",
    }),
    groupHeading: provided => ({
      ...provided,
      fontSize: "12px",
      letterSpacing: "0.01em",
      color: "black",
      opacity: "0.6",
    }),
    group: provided => ({
      ...provided,
      opacity: "0.5",
    }),
  };
  const [salaries, setSalaries] = React.useState<Salary[]>([]);
  const [families, setFamilies] = useState<Family[]>([]);
  const [activeParis, setActiveParis] = useState<boolean>(true);
  const [activeProvince, setActiveProvince] = useState<boolean>(false);
  const [responsibility, setResponsibility] = useState<string>(null);
  const [manager, setManager] = useState<boolean>(false);
  const [valueRange, setValueRange] = React.useState([0, 1]);
  const [experiencesYearValues, setExperiencesYearValues] = React.useState<string[]>(["0 - 2 ans", "3 - 5 ans"]);
  const [top, setTop] = useState<number>();
  const [duration, setDuration] = useState<number>();
  const [disable, setDisable] = useState<boolean>(true);
  const classes = rangeStyles();
  const circle = useRef();
  const topLine = useRef();
  const searchBar = useRef();

  useEffect(() => {
    const timeline = anime.timeline({
      delay: 200,
      duration: 1200,
      easing: "cubicBezier(0.74, 0.04, 0.34, 0.95)",
    });
    timeline
      .add({
        opacity: [0, 1],
        borderWidth: [0, 6],
        easing: "easeInOutQuad",
        targets: circle.current,
      })
      .add(
        {
          height: [0, 40],
          opacity: [0, 1],
          duration: 3000,
          easing: "easeOutExpo",
          targets: topLine.current,
        },
        600,
      )
      .add(
        {
          opacity: [0, 1],
          duration: 1000,
          targets: searchBar.current,
        },
        0,
      );
  }, []);

  useEffect(() => {
    client.get("/salary_simulators").then(response => {
      setSalaries(response.data["hydra:member"]);
    });
    if (mobile) {
      setTop(800);
      setDuration(1000);
    } else {
      setTop(600);
      setDuration(1000);
    }
  }, []);

  useEffect(() => {
    if (salaries && salaries.length) {
      const familiesGroup: Family[] = [];
      const roles: Role[] = [];
      salaries.map((salary: Salary) => {
        let family: Family;
        let role: Role;
        if (!familiesGroup.map((res: Family) => res.label).includes(salary.family)) {
          family = {
            ...family,
            "@id": salary["@id"],
            label: salary.family,
          };
          salaries.map((resultSalary: Salary) => {
            if (
              resultSalary.family === family.label &&
              resultSalary.experienceYears === "0 - 2 ans" &&
              resultSalary.manager === false &&
              resultSalary.localisation === "Paris"
            ) {
              role = {
                "@id": `id-${resultSalary.role}`,
                value: resultSalary.role,
                familyName: resultSalary.family,
              };
              roles.push(role);
            }
          });
          family = {
            ...family,
            options: roles.filter((role: Role) => role.familyName === family.label),
          };
          familiesGroup.push(family);
        }
      });
      setFamilies(familiesGroup);
    }
  }, [salaries]);

  const setParis = (active: boolean) => {
    return activeProvince ? setActiveParis(!active) : null;
  };

  const setProvince = (active: boolean) => {
    return activeParis ? setActiveProvince(!active) : null;
  };

  const onChange = value => {
    setResponsibility(value.value);
    value ? setDisable(false) : setDisable(true);
  };

  const onChangeManagement = (active: boolean) => {
    return setManager(!active);
  };

  const handleChangeRange = (_event, newValue) => {
    getStringInputRangeValue(newValue);
    return setValueRange(newValue);
  };

  const getStringInputRangeValue = (value: any) => {
    setExperiencesYearValues([]);
    let experiences: string[] = [];
    let experiencesArray;
    experiencesArray = marks.slice(value[0], value[1] + 1);
    experiencesArray.map((experience: { value: number; label: string }) => {
      experiences.push(experience.label);
    });
    setExperiencesYearValues(experiences);
  };

  const marks = [
    {
      value: 0,
      label: "0 - 2 ans",
    },
    {
      value: 1,
      label: "3 - 5 ans",
    },
    {
      value: 2,
      label: "6 - 10 ans",
    },
    {
      value: 3,
      label: "11 - 15 ans",
    },
    {
      value: 4,
      label: "15+ ans",
    },
  ];

  const submit = () => {
    if (firstResearch) {
      gtagService.event("click", {
        event_label: "rechercher - 1st click",
      });
      setFirstResearch(false);
    } else {
      gtagService.event("click", {
        event_label: "rechercher - extra clicks",
      });
    }
    const exp = experiencesYearValues.map(e => e.replace(/\s/g, "")).join(" - ");
    const actPa = activeParis ? "- Paris " : "";
    const actPr = activeProvince ? "- Province " : "";
    const actMa = manager ? "- Manager" : "";
    const envt = `recherche - ${responsibility} - ${exp} ${actPa}${actPr}${actMa}`;
    gtagService.event("click", {
      event_label: envt,
    });

    update({
      ...state,
      role: responsibility,
      range: experiencesYearValues,
      paris: activeParis,
      province: activeProvince,
      management: manager,
      salaries: salaries,
    });
    scrollToPosition();
  };

  const scrollToPosition = () => {
    const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
    anime({
      targets: scrollElement,
      duration,
      scrollTop: top,
      easing: "easeInOutQuad",
    });
  };

  return (
    <div className={styles.searchBarInnerContainer}>
      <div className={styles.circle} ref={circle} />
      <div className={styles.topLine} ref={topLine} />
      <div className={styles.searchBar} ref={searchBar}>
        <div className={styles.roles}>
          <h3>Rôles</h3>
          <div className={styles.searchRoles}>
            <div className={styles.searchIcon}>
              <Img fluid={data.searchIcon.childImageSharp.fluid} alt="searchIcon" />
            </div>
            <Select
              menuPlacement="auto"
              arrowRenderer={false}
              className={styles.myInput}
              getOptionValue={option => option["@id"]}
              getOptionLabel={option => option.value}
              onChange={value => onChange(value)}
              options={families}
              placeholder="Métier recherché"
              styles={selectStyles}
              theme={theme => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  primary25: "#DADADA",
                  primary: "#EEEEEE",
                },
              })}
            />
          </div>
        </div>
        <div
          className={cx(styles.mobileHidden, {
            [styles.disable]: disable && responsibility === null,
          })}
        >
          <div
            className={cx(styles.experiencesYearsWrapper, {
              [styles.disable]: disable,
            })}
          >
            <h3>Années d'expériences</h3>
            <div className={styles.experiencesYears}>
              <div className={cx(styles.sliderWrapper)}>
                <div className={styles.slider}>
                  <Slider
                    classes={{
                      markLabelActive: classes.markLabelActive,
                      markLabel: classes.markLabel,
                      mark: classes.mark,
                      rail: classes.rail,
                      track: classes.track,
                      thumb: classes.thumb,
                    }}
                    max={4}
                    marks={marks}
                    value={valueRange}
                    onChange={handleChangeRange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={cx(styles.localisationWrapper, {
              [styles.disable]: disable,
            })}
          >
            <h3>Localisation</h3>
            <div className={cx(styles.buttons)}>
              <button
                className={cx(styles.button, { [styles.active]: activeParis })}
                disabled={disable}
                onClick={() => setParis(activeParis)}
              >
                Paris
              </button>
              <button
                className={cx(styles.button, {
                  [styles.active]: activeProvince,
                })}
                disabled={disable}
                onClick={() => setProvince(activeProvince)}
              >
                Province
              </button>
            </div>
          </div>
          <div className={cx(styles.switchWrapper, { [styles.disable]: disable })}>
            <h3>Avec management</h3>
            <label className={styles.toggle}>
              <input disabled={disable} type="checkbox" onClick={() => onChangeManagement(manager)} />
              <span className={cx(styles.slider, styles.round)}></span>
            </label>
          </div>
          <div className={cx(styles.buttonWrapper, { [styles.disable]: disable })}>
            <button className={styles.button} disabled={disable} onClick={() => submit()}>
              Rechercher
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
